import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

type MySpinnerProps = {
  size?: 'small' | 'medium' | 'large'
  inverse?: boolean
  isInButton?: boolean
}
export const MySpinner = ({ size = 'medium', inverse = false, isInButton = false }: MySpinnerProps) => {
  const { t } = useTranslation('common')

  const classes = classNames('ds-c-spinner', {
    'ds-c-spinner--small': size === 'small',
    'ds-c-spinner--large': size === 'large',
    'ds-c-spinner--inverse': inverse === true,
    'my-c-spinner--in-button': isInButton === true
  })

  // Use markup rather than the Design System's Spinner component to avoid an accesibility issue.
  // Due to the component default values, the rendered HTML always has an aria-textvalue attribute,
  // which is incompatible with the "status" role.
  return (
    <span className={classes} role="status">
      <span className="ds-u-visibility--screen-reader">{t('loading')}</span>
    </span>
  )
}
